import { render, staticRenderFns } from "./helpDesk.vue?vue&type=template&id=1e92b657&scoped=true"
import script from "./helpDesk.vue?vue&type=script&lang=js"
export * from "./helpDesk.vue?vue&type=script&lang=js"
import style0 from "./helpDesk.vue?vue&type=style&index=0&id=1e92b657&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e92b657",
  null
  
)

export default component.exports